<div class="bg-blue-2 d-flex al-center sp-between p-4">
  <div>
    <div>
      <span class="text-white fw-extrabold fs-4">Tipo de pregunta</span>
    </div>
    <div>
      <span class="text-white fs-6 fw-regular">Escoge el tipo de pregunta que vas a formular</span>
    </div>
  </div>
  <div>
    <img src="assets/svg/Icon_close.svg" mat-dialog-close alt="">
  </div>
</div>
<mat-dialog-content class="p-4 d-flex flex-column content-form">
  <div class="mb-3">
    <span class="fs-6 fw-regular">Tenemos 4 opciones disponibles.</span>
  </div>
  <div class="d-flex al-center gap mb-5">
    <div class="content-option w-100 rounded d-flex al-center sp-center rounded animated pointer" 
    *ngFor="let option of optionsQuest" [ngClass]="option.state ? 'bg-blue-transparent':'border'" (click)="changeState(option)">
      <div class="d-flex flex-column al-center">
        <img [src]="!option.state ? option.icon : option.iconSelected " alt="" width="40" class="mb-3">
        <span class="fs-7 fw-regular" [ngClass]="option.state ? 'text-blue':'text-secondary'">{{option.label}}</span>
      </div>
    </div>
  </div>
  <hr>
</mat-dialog-content>
<div class="p-4 text-end content-action">
  <mat-dialog-actions align="end">
    <button mat-flat-button class="bg-blue-2" (click)="guardarOptionQuestion()">
      <span class="fw-bold fs-5 text-white me-3">Continuar</span>
      <img src="assets/svg/Icon_arrow_right_white.svg" alt="">
    </button>
  </mat-dialog-actions>
</div>